/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
import React,{useContext, useState} from 'react'
import S3UploadHook from '../../CommonMethods/S3UploadHook'
import ErrorMessage from '../ErrorMessage'
import UploadProgress from '../UploadProgress'
import { pushOrRemoveElement } from '../../CommonMethods/pushOrRemoveElement'
import GlobalContext from '../Context/GloablContext'

export default function UploadFileInput({
    state,
    id,
    formatError,
    setstate,
    setformatError,
    setimageLoading,
    imageLoading,
    submitSelected,
    optional,
    text,
    mainKey,
    setsubmitSelected
}) {
    const {setToastErrorMessage} = useContext(GlobalContext);
    const imageTypes=['image/png','image/jpeg','image/jpg','application/pdf']
    const [progressCount, setprogressCount] = useState(0)
    //Upload file
    async function handleUploadChange(e) {
        setformatError('')
        const path =`${mainKey}/${e.target.id}`
        const selectedFile = e.target.files[0];
        setimageLoading(e.target.id)
        if (e.target.files) {
            if(!imageTypes.includes(e.target.files[0].type )){
                setformatError(e.target.id);
                e.target.value = null
                setimageLoading('')
                setToastErrorMessage('The uploaded file does not meet the required file format or size. Please try again')
            
            }
            else if((selectedFile && selectedFile.size > 10 * 1024 * 1024) ){
                // setOpen('')
                // const errorElement = pushOrRemoveElement(formatError, e.target.id)
                setformatError(e.target.id);
                e.target.value = null
                setimageLoading('')
                setToastErrorMessage('File size cannot be more than 10mb')
                // return

            }else{
                // setloading('upload')
                const file = e.target.files[0];
                const fileLink = URL.createObjectURL(file);   
                let url=''
                if(file.name && file.type){
                    url= await S3UploadHook(file,`${mainKey}/${id}`,setprogressCount); 

                    const val =`${mainKey}/${id}/${file.name}`

                    setstate((prv)=>({
                        ...prv,
                        [id]:url
                    }))
                    setimageLoading('')

                    return                    
                    // handleSubmit(file,fileLink)
                } 
            }
            
        }
        
    }
    //remove file
    const handleRemove =(key)=>{
        setstate((prv)=>({
            ...prv,
            [key]:''
        }))
    }
    return (
        
        
        <div>
            < >
               
                {state[id]===''?
                    <div className={`${((submitSelected&& state[id] === '' && optional===undefined) || formatError === id )? "border-[#F04438]" : "border-[#106EB4]"} border rounded w-max uploadFileBtn`}>
                        <label htmlFor="inp" className="p-1.5 flex items-center cursor-pointer relative">
                            <div className='cursor-pointer'>
                                {imageLoading == id?

                                    <div className='w-[104px] flex items-center justify-center'><UploadProgress progressCount={progressCount} /></div>
                                    :
                                    <div className='flex'>
                                        <span className="text-f1 text-[#106EB4] cursor-pointer">Upload File</span>
                                        <img loading="lazy" decoding="async" src="/images/upload-cloud.svg" alt="img" className="ml-1 cursor-pointer"/>

                                    </div>
                                }
                            </div>
                            <input 
                                type="file" 
                                id={id}
                                data-test="file"
                                title=""
                                onFocus={()=>{
                                    if(optional === undefined) {
                                        setsubmitSelected(false);
                                    }
                                    // if(setcustomError){
                                    //     setcustomError([])
                
                                    // }
                                }}
                                accept="image/jpeg, image/png, application/pdf" 
                                onChange={(e)=>handleUploadChange(e)}
                                className="opacity-0 absolute top-0 left-0 z-[999] cursor-pointer"  
                                style={{width:'120px',height:'44px'}} />
                        </label>
                    </div>:
                    <div className="flex items-center justify-between uploaded_file ">
                        <p className="mr-2 text-sm font-normal text-[#031624] more-lines w-[80%]" title={state[id] && state[id].split('/')[3]}>{state[id] && state[id].split('/')[3]}</p>
                        <div className='relative group w-[15%]'>
                            <img
                                src="/images/file-remove.svg" 
                                alt="icon"
                                loading="lazy"
                                className="cursor-pointer"
                                id = "cross-click"
                                onClick={() => handleRemove(id)}
                                class="w-4 h-4"
                            />
                            <span class="absolute top-6 left-1/2 transform -translate-x-1/2 scale-0 inline-flex flex-shrink-0 justify-center items-center gap-2.5 p-2.5 h-5 rounded-sm bg-[#d0d5dd] text-[#344054] text-xs font-medium leading-[12.5px] group-hover:scale-100">Remove</span>
                        </div>
                    </div>
                }
            </>
            {/* {!submitSelected && formatError ===id  && 
                <ErrorMessage error 
                    message="The uploaded file does not meet the required file format or size. Please try again" 
                    classKey="text-f1 font-normal text-[#F04438] add-error2 pt-1.5" />}
            {(submitSelected&& state[id] === '' &&optional===undefined)&&
                <ErrorMessage
                    message={text}
                    error
                    classKey="text-f1 font-normal text-[#F04438] add-error2 pt-1.5"

                />}   */}
        </div>
    )
}
